// src/App.jsx — v13
// CHANGED FROM v12 (3 Aug 2026): REVERTED — v12's React.lazy() code-
// splitting introduced a REAL, confirmed live bug: on a fresh/direct
// page load (typing a URL directly, not navigating via in-app links),
// the page's own CSS chunk could finish loading AFTER the page's HTML
// had already rendered, leaving a completely unstyled page (confirmed
// via DevTools Network tab: every CSS file showed Status 200/fully
// loaded, but still rendered unstyled — a known real issue with
// route-level code-splitting when a route's CSS gets split into its
// own chunk separate from the main bundle). Confirmed reproducible on
// both /shop and /about, in Incognito (ruling out extensions), on the
// live site. Since this affects real visitors landing directly via a
// shared link, bookmark, or search result — not just in-app
// navigation — reverted immediately to the known-stable v11 behavior
// (eager imports, no code-splitting) rather than attempt a rushed fix
// live. Proper code-splitting needs local testing before redeploying,
// with shared/critical CSS deliberately kept OUT of per-route chunks
// — real, scoped fix for a future session, not tonight.
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { StoreProvider } from './context/StoreContext';
import { initPixel } from './utils/pixel';
import './index.css';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import GenderHome from './pages/GenderHome';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import Login from './pages/Login';
import Account from './pages/Account';
import AccountAddresses from './pages/AccountAddresses';
import OrderHistory from './pages/OrderHistory';
import WalletStatement from './pages/WalletStatement';
import ResellerDashboard from './pages/ResellerDashboard';
import ResellerInfo from './pages/ResellerInfo';
import Wishlist from './pages/Wishlist';
import About from './pages/About';
import Contact from './pages/Contact';
import Returns from './pages/Returns';
import Shipping from './pages/Shipping';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Loyalty from './pages/Loyalty';
import AdminPanel from './pages/AdminPanel';
import WhatsAppWidget from './components/WhatsAppWidget';
// import GoogleTranslate from './components/GoogleTranslate';
const TablerScript = () => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/tabler-icons.min.css';
    document.head.appendChild(link);
    initPixel();
  }, []);
  return null;
};
export default function App() {
  return (
    <StoreProvider>
      <TablerScript />
      {/* <GoogleTranslate /> */}
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/women" element={<GenderHome gender="Women" />} />
          <Route path="/men" element={<GenderHome gender="Men" />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-success" element={<OrderSuccess />} />
          <Route path="/login" element={<Login />} />
          <Route path="/account" element={<Account />} />
          <Route path="/account/addresses" element={<AccountAddresses />} />
          <Route path="/account/orders" element={<OrderHistory />} />
          <Route path="/account/wallet-statement" element={<WalletStatement />} />
          <Route path="/reseller" element={<ResellerDashboard />} />
          <Route path="/reseller-info" element={<ResellerInfo />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cashback-program" element={<Loyalty />} />
          <Route path="/amitspanel-admin" element={<AdminPanel />} />
        </Routes>
        <WhatsAppWidget />
      </BrowserRouter>
    </StoreProvider>
  );
}